export class Constants {
    static ACCESS_TOKEN_KEY = 'accessToken';
    static USER_PROFILE_KEY = 'userProfile';
    static CONTENT_TYPE_KEY = 'Content-Type';
    static APPLICATION_JSON = 'application/json';
    static MULTIPART_FORM_DATA = 'multipart/form-data';
    static AUTHORIZATION_KEY = 'authorization';
    static BASE_URL = 'https://subscription.illinoiscourtservices.net/subscription/'; // Prod Server
    // static BASE_URL = 'https://testsubscription.illinoiscourtservices.net/subscription/'; // Test Server
    // static BASE_URL = 'http://192.168.1.145:8080/subscription/'; // Local Server
    static SECURE_PATH = 's/adm/';
    static API_PATH_SEPARATOR = '/';
    static DATE_FORMAT = 'MM/dd/yyyy';
    static SUBSCRIBER_USER_CODE = "SUBSCRIBER_USER"; // PR 966
    static MSA_MAX_FILE_SIZE = 5 * 1024 * 1024; // PR 985
}
